import { Box, Button, Hidden, IconButton, Typography } from "@mui/material";
import { IoLogInOutline, IoLogOutOutline } from "react-icons/io5";
import { RiAccountCircleFill } from "react-icons/ri";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { AuthRepository } from "../repositories/AuthRepository";
import { useTheme } from "@emotion/react";
import { GiHamburgerMenu } from "react-icons/gi";
import { setMenuOpen } from "../../store/MenuSlice";

export default function LoginHeader() {
  const theme = useTheme();
  const auth = useSelector((state) => state.auth);
  const menu = useSelector((state) => state.menu);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: { md: "flex-end", xs: "space-between" },
        overflowX: "hidden",
        overflowY: "hidden",
        width: "100%",
        zIndex: 1,
        overflowX: "hidden",
        maxWidth: "100%",
        boxSizing: "border-box",
        padding: { xs: "5px 5px", md: "5px 20px" },
        backgroundColor: "#f2f9ff",
        gap: 3,
      }}
    >
      <Hidden mdUp>
        <IconButton onClick={() => dispatch(setMenuOpen(!menu.open))}>
          <GiHamburgerMenu />
        </IconButton>
      </Hidden>
      {auth?.userData ? (
        <>
          <Hidden smDown>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "4px",
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
                color: theme.palette.secondary.main,
              }}
            >
              <RiAccountCircleFill fontSize={22} color="#969696" />
              <Typography
                noWrap
                style={{
                  fontSize: "14px",
                  fontFamily: "Inter-Regular",
                }}
              >
                {auth.userData.firstname + " " + auth.userData.lastname}
              </Typography>
            </div>
          </Hidden>
          <Button
            variant="transparent"
            onClick={() => {
              if (window.location.pathname !== "/") {
                navigate("/");
              }
              AuthRepository.logout();
            }}
          >
            <IoLogOutOutline size={24} color={theme.palette.secondary.main} />
            <Hidden smDown>
              <Typography
                variant="caption"
                sx={{
                  fontSize: "14px",
                  fontFamily: "Inter-Regular",
                  marginLeft: "2px",
                  color: theme.palette.secondary.main,
                }}
              >
                Одјава
              </Typography>
            </Hidden>
          </Button>
        </>
      ) : (
        <Button variant="transparent" onClick={() => navigate("/login")}>
          <IoLogInOutline size={24} color={theme.palette.secondary.main} />
          <Typography
            variant="caption"
            sx={{
              fontSize: "14px",
              fontFamily: "Inter-Regular",
              marginLeft: "2px",
              color: theme.palette.secondary.main,
            }}
          >
            Најава
          </Typography>
        </Button>
      )}
    </Box>
  );
}
